"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'home_title',
  cname: '标题',
  icon: 't-icon-zujian-biaoti',
  configName: 'c_home_title',
  type: 3,
  // 0 基础组件 1 营销组件 2会员 3工具组件
  defaultName: 'titles',
  // 外面匹配名称
  props: {
    index: {
      type: null
    },
    num: {
      type: null
    }
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapState)('mobildConfig', ['defaultArray'])), {}, {
    //最外层盒子的样式
    boxStyle: function boxStyle() {
      return [{
        'border-radius': this.configObj.bgTopStyle.val + 'px' + ' ' + this.configObj.bgTopStyle.val + 'px' + ' ' + this.configObj.bgDownStyle.val + 'px' + ' ' + this.configObj.bgDownStyle.val + 'px'
      }, {
        'background-image': this.selectStyle ? "linear-gradient(to right,".concat(this.configObj.bgColor.color[0].item, ", ").concat(this.configObj.bgColor.color[1].item, ")") : "url(".concat(this.bgImgUrl, ")")
      }, {
        margin: this.configObj.mbConfig.val + 'px' + ' ' + this.configObj.lrConfig.val + 'px' + ' ' + 0
      }, {
        padding: this.configObj.upConfig.val + 'px' + ' ' + '10px' + ' ' + this.configObj.downConfig.val + 'px'
      }];
    },
    titleStyle: function titleStyle() {
      return [{
        'font-weight': this.configObj.textStyle.tabVal == 2 ? this.configObj.textStyle.list[this.configObj.textStyle.tabVal].style : ''
      }, {
        'font-style': this.configObj.textStyle.tabVal != 2 ? this.configObj.textStyle.list[this.configObj.textStyle.tabVal].style : ''
      }, {
        fontSize: this.configObj.fontSize.val + 'px'
      }, {
        color: this.configObj.fontColor.color[0].item
      }];
    },
    titleFuStyle: function titleFuStyle() {
      return [{
        fontSize: this.configObj.fontFuSize.val + 'px'
      }, {
        color: this.configObj.fontFuColor.color[0].item
      }];
    },
    titleRightStyle: function titleRightStyle() {
      return [{
        fontSize: this.configObj.fontRightSize.val + 'px'
      }, {
        color: this.configObj.fontRightColor.color[0].item
      }];
    }
  }),
  watch: {
    pageData: {
      handler: function handler(nVal, oVal) {
        this.setConfig(nVal);
      },
      deep: true
    },
    num: {
      handler: function handler(nVal, oVal) {
        var data = this.$store.state.mobildConfig.defaultArray[nVal];
        this.setConfig(data);
      },
      deep: true
    },
    defaultArray: {
      handler: function handler(nVal, oVal) {
        var data = this.$store.state.mobildConfig.defaultArray[this.num];
        this.setConfig(data);
      },
      deep: true
    },
    selectShow: {
      handler: function handler(nVal, oVal) {
        if (nVal == 0) {
          this.configObj.titleRightConfig.isShow = 1;
        } else {
          this.configObj.titleRightConfig.isShow = 0;
        }
      },
      deep: true
    },
    selectStyle: {
      handler: function handler(nVal, oVal) {
        if (nVal == 0) {
          this.configObj.bgImg.isShow = 1;
          this.configObj.bgColor.isShow = 0;
        } else {
          this.configObj.bgImg.isShow = 0;
          this.configObj.bgColor.isShow = 1;
        }
      },
      deep: true
    }
  },
  data: function data() {
    return {
      defaultConfig: {
        name: 'titles',
        timestamp: this.num,
        setUp: {
          tabVal: 0,
          cname: '标题'
        },
        titleConfig: {
          tabTitle: '文本标题',
          title: '标题名称',
          val: '标题',
          place: '请输入标题，限制8个字以内',
          max: 8,
          isShow: 1
        },
        titleFuConfig: {
          tabTitle: '文本标题',
          title: '副标题',
          val: '副标题',
          place: '请输入副标题，限制12个字以内',
          max: 12,
          isShow: 1
        },
        titleRightConfig: {
          tabTitle: '右侧文字',
          title: '右侧文字',
          val: '更多',
          place: '请输入右侧文字，限制4个字以内',
          max: 4,
          isShow: 1
        },
        bgImg: {
          isShow: 1,
          title: '上传背景图',
          tips: '建议：910px*86px',
          url: ''
        },
        selectShow: {
          cname: 'selectShow',
          title: '右侧按钮',
          tabVal: 0,
          isShow: 1,
          list: [{
            val: '显示'
          }, {
            val: '隐藏'
          }]
        },
        selectStyle: {
          cname: 'selectStyle',
          title: '选择风格',
          tabVal: 0,
          isShow: 1,
          list: [{
            val: '背景图片'
          }, {
            val: '背景色'
          }]
        },
        // 背景颜色
        bgColor: {
          tabTitle: '颜色设置',
          title: '背景颜色',
          isShow: 1,
          color: [{
            item: '#FFFFFF'
          }, {
            item: '#FFFFFF'
          }],
          default: [{
            item: '#FFFFFF'
          }, {
            item: '#FFFFFF'
          }]
        },
        linkConfig: {
          title: '链接',
          val: '',
          place: '请输入链接地址',
          max: 100,
          isShow: 1
        },
        fontColor: {
          title: '标题颜色',
          tabTitle: '文字设置',
          name: 'fontColor',
          default: [{
            item: '#282828'
          }],
          color: [{
            item: '#282828'
          }]
        },
        bgTopStyle: {
          tabTitle: '圆角设置',
          title: '上圆角',
          name: 'bgStyle',
          val: 0,
          min: 0,
          max: 30
        },
        bgDownStyle: {
          title: '下圆角',
          name: 'bgStyle',
          val: 0,
          min: 0,
          max: 30
        },
        textStyle: {
          title: '文本样式',
          isShow: 1,
          tabVal: 0,
          list: [{
            val: '正常',
            style: 'normal',
            icon: 'icon-zhengchang'
          }, {
            val: '斜体',
            style: 'italic',
            icon: 'icon-qingxie'
          }, {
            val: '加粗',
            style: 'bold',
            icon: 'icon-jiacu'
          }]
        },
        fontSize: {
          title: '标题文字',
          val: 20,
          min: 12,
          max: 30
        },
        fontFuColor: {
          title: '副标题颜色',
          tabTitle: '文字设置',
          name: 'fontFuColor',
          default: [{
            item: '#282828'
          }],
          color: [{
            item: '#282828'
          }]
        },
        fontFuSize: {
          title: '副标题文字',
          val: 14,
          min: 12,
          max: 20
        },
        fontRightColor: {
          title: '按钮颜色',
          tabTitle: '文字设置',
          name: 'fontFuColor',
          default: [{
            item: '#282828'
          }],
          color: [{
            item: '#282828'
          }]
        },
        fontRightSize: {
          title: '按钮文字',
          val: 12,
          min: 12,
          max: 20
        },
        // 上间距
        upConfig: {
          title: '上边距',
          tabTitle: '边距设置',
          val: 10,
          min: 0,
          max: 100
        },
        // 下间距
        downConfig: {
          tabTitle: '边距设置',
          title: '下边距',
          val: 10,
          min: 0
        },
        // 左右间距
        lrConfig: {
          title: '左右边距',
          val: 12,
          min: 0,
          max: 40
        },
        mbConfig: {
          title: '页面间距',
          val: 10,
          min: 0
        }
      },
      configObj: null,
      titleTxt: '',
      titleFuTxt: '',
      titleRightTxt: '',
      link: '',
      txtPosition: '',
      txtStyle: '',
      fontSize: 0,
      mTOP: 0,
      titleColor: '',
      themeColor: '',
      prConfig: 0,
      bgStyle: 0,
      pageData: {},
      selectShow: '',
      selectStyle: '',
      bgImgUrl: ''
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      if (_this.num) {
        _this.pageData = _this.$store.state.mobildConfig.defaultArray[_this.num];
        _this.setConfig(_this.pageData);
      }
    });
  },
  methods: {
    setConfig: function setConfig(data) {
      if (!data) return;
      if (data) {
        this.configObj = data;
        this.titleTxt = data.titleConfig.val;
        this.titleFuTxt = data.titleFuConfig.val;
        this.titleRightTxt = data.titleRightConfig.val;
        this.link = data.linkConfig.val;
        this.selectShow = this.configObj.selectShow.tabVal;
        this.selectStyle = this.configObj.selectStyle.tabVal;
        this.bgImgUrl = this.configObj.bgImg.url;
      }
    }
  }
};